import "./../../bindings/foreach-selection";
import "./../../bindings/bao-pager";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
function Device3AssignmentTab(tabPage, device3ViewModel) {
    var self = this;
    self.TabPage = tabPage;
    self.Device3ViewModel = device3ViewModel;
    self.Selection = ko.observableArray();
    self.SelectedEquipments = ko.observableArray();
    self.Sorting = ko.observableArray();
    self.PageSize = ko.observable(20);
    self.PageIndex = ko.observable(0);
    self.TotalRows = ko.observable();
    self.Models = ko.observableArray();
    self.NewArray = ko.observableArray([]);
    self.PageIndex.subscribe(function () {
        self.Refresh();
    });
    self.PageSize.subscribe(function () {
        if (self.PageIndex() != 0) {
            self.PageIndex(0);
        }
        else {
            self.Refresh();
        }
    });
    self.Sorting.subscribe(function () {
        self.Refresh();
    });
    self.Selection.subscribe(function () {
        self.toggleButtons();
    });
    self.SelectedEquipments.subscribe(function (selectedEquipments) {
        if (selectedEquipments != null && selectedEquipments.length > 0) {
            var equipmentIds = [];
            ko.utils.arrayForEach(selectedEquipments, function (item: any) {
                equipmentIds.push(ko.unwrap(item.AreaEquipmentId));
            });
            self.addEquipmentToSession(equipmentIds);
        }
    });
    self.toolbarButtonClicked = function (btn) {
        if (self.TabPage != null && self.TabPage.IsActiveTab != null && self.TabPage.IsActiveTab() === true) {
            var functionString = btn.ActionKey().substr(('Device3EquipmentAssignment').length);
            switch (functionString) {
                case 'Add':
                    self.addEquipment();
                    break;
                case 'Remove':
                    self.removeEquipment();
                    break;
                default:
                    break;
            }
        }
    };
    self.toolbarLoaded = function () {
        self.toggleButtons();
    };
    self.addEquipment = function (equipment) {
        this.openEquipmentSearcher();
    };
    self.openEquipmentSearcher = function () { };
}
;
Device3AssignmentTab.prototype.Refresh = function () {
    var self = this;
    self.TabPage.IsLoading(true);
    return Bao.post("MasterData/Device3/GetAssignedEquipments", JSON.stringify({
        sessionTabId: self.Device3ViewModel.SessionTabId(),
        device3Id: self.Device3ViewModel.Device3Id(),
        pageIndex: self.PageIndex(),
        pageSize: self.PageSize(),
        sorting: self.Sorting()
    }), function (searchResult) {
        self.SelectedEquipments([]);
        self.NewArray([]);
        self.TotalRows(0);
        self.Models([]);
        if (searchResult != null && searchResult.Models != null) {
            self.Models(searchResult.Models);
            self.TotalRows(searchResult.TotalRows);
            self.toggleButtons();
        }
    }).always(function () {
        self.TabPage.IsLoading(false);
    });
};
Device3AssignmentTab.prototype.toggleButtons = function () {
    if (this.enableButton != undefined) {
        var selection = this.Selection.peek();
        this.enableButton('Device3EquipmentAssignmentRemove', selection && (selection.length > 0));
    }
};
Device3AssignmentTab.prototype.removeEquipment = function (a, b, c) {
    var self = this;
    self.TabPage.IsLoading(true);
    var equipmentIds = [];
    ko.utils.arrayForEach(self.Selection(), function (item: any) {
        equipmentIds.push(ko.unwrap(item.AreaEquipmentId));
    });
    return Bao.post("MasterData/Device3/DeleteEquipment", JSON.stringify({
        sessionTabId: self.Device3ViewModel.SessionTabId(),
        device3Id: self.Device3ViewModel.Device3Id(),
        equipmentIds: equipmentIds
    }), function () {
        self.Device3ViewModel.TabPage.DirtyFlag(true);
        self.Refresh();
    });
};
Device3AssignmentTab.prototype.addEquipmentToSession = function (equipments) {
    var self = this;
    self.TabPage.IsLoading(true);
    return Bao.post("MasterData/Device3/AddEquipment", JSON.stringify({
        sessionTabId: self.Device3ViewModel.SessionTabId(),
        device3Id: self.Device3ViewModel.Device3Id(),
        equipmentIds: equipments
    }), function () {
        self.Device3ViewModel.TabPage.DirtyFlag(true);
        self.Refresh();
    });
};
export default Device3AssignmentTab;